module.exports = __webpack_public_path__ + "img/desktop-logo.b120e78.svg";